// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2026-06-25: Buildings master page — minimal additive styles on top of MachineGroup look */
.building_item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.building_info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.building_meta {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}

.building_meta strong {
  color: #111827;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/app/Pages/Buildings/buildings.css"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* 2026-06-25: Buildings master page — minimal additive styles on top of MachineGroup look */\n.building_item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.building_info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.building_meta {\n  font-size: 11px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.building_meta strong {\n  color: #111827;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
